module.exports = __webpack_public_path__ + "static/media/Maf_Curso_02ProtocoloEstambul.be7a6450.jpg";